import type { SupabaseClient } from '@supabase/supabase-js';

export type FeatureKeyCore = 'desktop_app' | 'ios_app' | 'android_app';

export async function getFeatureInterestCore(sb: SupabaseClient, userId: string): Promise<{ desktop_app: boolean; ios_app: boolean; android_app: boolean }> {
    const { data, error } = await sb
        .from('future_feature_interest')
        .select('feature, interested')
        .eq('user_id', userId);
    if (error) throw error;
    const base = { desktop_app: false, ios_app: false, android_app: false };
    for (const row of (data || []) as any[]) {
        if (row.feature in base) (base as any)[row.feature] = !!row.interested;
    }
    return base;
}

export async function upsertFeatureInterestCore(sb: SupabaseClient, userId: string, feature: FeatureKeyCore, interested: boolean): Promise<void> {
    const { error } = await sb
        .from('future_feature_interest')
        .upsert({ user_id: userId, feature, interested }, { onConflict: 'user_id,feature' });
    if (error) throw error;
}
